export default __webpack_public_path__ + "static/media/intersetialBigImg.0ca27f59.svg";